import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="fade-up"
// Replicates AOS fade-up with per-item delay via data-fade-up-delay attributes.
// Disabled on mobile (max-width: 768px), runs once per element.
export default class extends Controller {
  static targets = ['item']

  connect() {
    if (window.matchMedia('(max-width: 768px)').matches) return

    // Initial state (opacity-0 translate-y-10) is set via CSS classes in HTML
    // to avoid a flash of visible content before JS connects.
    // Here we only add the transition, then animate to visible on intersection.
    // Tailwind v4 uses the CSS `translate` property (not `transform`) for
    // translate-y-* classes, so we transition on `translate`, not `transform`.
    this.itemTargets.forEach(item => {
      item.style.transition = 'opacity 0.6s ease, translate 0.6s ease'
    })

    // Watch each item: when 10% of it enters the viewport, trigger the
    // fade-up after the item's own delay (data-fade-up-delay, in ms).
    // Once animated, the item is unobserved so the callback fires only once.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          const delay = parseInt(entry.target.dataset.fadeUpDelay || 0)
          setTimeout(() => {
            entry.target.style.opacity = '1'
            entry.target.style.translate = 'none'
          }, delay)
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.1 }
    )

    this.itemTargets.forEach(item => observer.observe(item))
  }
}
